module.exports = __webpack_public_path__ + "static/avatar-13b85cf251dc8d296ff16c1eb2a51c59.jpg";